import { Field, FieldArray, useFormikContext } from 'formik';
import React, { useState } from 'react';
import Input from '../../../../components/input/Input';
import Button from '../../../../components/button/Button';
import { Collapse, DatePicker, Select } from 'antd';
import { PlusIcon } from '../../../../components/icons';
import { ConfigData } from '../../../../customhooks/investments/useInvestmentOptions';
import dayjs from 'dayjs';
import { DocumentUploader } from '../../../../components/DocumentUploader';
import UploadPassport from './UploadPassport';
import { signatorySchema } from './Onboarding';
import * as Yup from 'yup';

const { Panel } = Collapse;

const InvestmentSignatories = ({
    investmentOptions,
    isLoading
}: {
    investmentOptions: ConfigData;
    isLoading: boolean;
}) => {
    const {
        values,
        setFieldValue,
        isValid,
        errors,
        touched,
        setTouched
    } = useFormikContext<any>();
    const [activeKey, setActiveKey] = useState<string | string[]>();

    const handleAccordionChange = (key: string | string[]) => {
        setActiveKey(key);

        if (key && key.length > 0) {
            setTimeout(() => {
                setTouched({}, false);
            }, 0);
        }
    };

    return (
        <div className='space-y-4 max-w-lg'>
            <h2 className='text-lg font-medium'>
                Provide your signatory details and contact information
            </h2>

            <FieldArray name='signatories'>
                {({ push, remove }) => (
                    <div className='space-y-4'>
                        <Collapse
                            accordion
                            expandIconPosition='end'
                            activeKey={activeKey}
                            onChange={handleAccordionChange}
                        >
                            {values.signatories.map(
                                (signature: any, index: number) => {
                                    const isEditing =
                                        values.editingIndex === index;

                                     const hasRequiredFields =
                                        signature.firstName?.trim() &&
                                        signature.lastName?.trim() &&
                                        signature.email?.trim();

                                    return (
                                        <Panel
                                            key={index}
                                            header={
                                                <div className='flex items-center gap-4'>
                                                    {SignatoryIcon}
                                                    <span className='font-medium'>
                                                        {signature.firstName ||
                                                        signature.lastName
                                                            ? `${
                                                                  signature.firstName ||
                                                                  ''
                                                              } ${
                                                                  signature.lastName ||
                                                                  ''
                                                              }`
                                                            : `Signatory ${
                                                                  index + 1
                                                              }`}
                                                    </span>
                                                </div>
                                            }
                                        >
                                            {isEditing ? (
                                                // ====================== EDIT MODE ======================
                                                <div
                                                    className='space-y-2'
                                                    onFocus={(e) =>
                                                        e.stopPropagation()
                                                    }
                                                    onClick={(e) =>
                                                        e.stopPropagation()
                                                    }
                                                >
                                                    <UploadPassport
                                                        index={index}
                                                        url={
                                                            signature?.passportUrl
                                                        }
                                                        editable
                                                    />
                                                    <div className='flex w-full gap-2 items-start'>
                                                        <div className='flex-1 w-full'>
                                                            <Field
                                                                as={Input}
                                                                className='w-full'
                                                                placeholder='Enter first name'
                                                                label='First Name'
                                                                name={`signatories.${index}.firstName`}
                                                                id={`signatories.${index}.firstName`}
                                                                isError={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]
                                                                        ?.firstName &&
                                                                    (errors?.signatories as any)
                                                                        ?.firstName
                                                                }
                                                                errorMessage={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]
                                                                        ?.firstName &&
                                                                    (errors?.signatories as any)
                                                                        ?.firstName
                                                                }
                                                            />
                                                        </div>
                                                        <div className='flex-1 w-full'>
                                                            <Field
                                                                as={Input}
                                                                className='w-full'
                                                                placeholder='Enter last name'
                                                                label='Last Name'
                                                                name={`signatories.${index}.lastName`}
                                                                id={`signatories.${index}.lastName`}
                                                                isError={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]
                                                                        ?.lastName &&
                                                                    (errors?.signatories as any)
                                                                        ?.lastName
                                                                }
                                                                errorMessage={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]
                                                                        ?.lastName &&
                                                                    (errors?.signatories as any)
                                                                        ?.lastName
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='flex w-full gap-2 items-start'>
                                                        <div className='flex-1 w-full'>
                                                            <Field
                                                                as={Input}
                                                                className='w-full'
                                                                placeholder='Enter middle name'
                                                                label='Middle Name'
                                                                name={`signatories.${index}.middleName`}
                                                                id={`signatories.${index}.middleName`}
                                                            />
                                                        </div>
                                                        <div className='w-full flex-1'>
                                                            <label className='block mb-2 text-sm font-medium text-gray700 text-left'>
                                                                Date of Birth
                                                            </label>
                                                            <DatePicker
                                                                placeholder='Date of Birth'
                                                                value={
                                                                    signature.dob
                                                                        ? (dayjs(
                                                                              signature.dob
                                                                          ) as any)
                                                                        : null
                                                                }
                                                                onChange={(
                                                                    date
                                                                ) => {
                                                                    setFieldValue(
                                                                        `signatories.${index}.dob`,
                                                                        date
                                                                            ? date.format(
                                                                                  'YYYY-MM-DD'
                                                                              )
                                                                            : ''
                                                                    );
                                                                }}
                                                                format='YYYY-MM-DD'
                                                                style={{
                                                                    width:
                                                                        '100%',
                                                                    height:
                                                                        '40px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='flex w-full gap-2 items-start'>
                                                        <div className='flex-1'>
                                                            <Field
                                                                as={Input}
                                                                placeholder='Enter Email Address'
                                                                label='Email Address'
                                                                type='email'
                                                                name={`signatories.${index}.email`}
                                                                id={`signatories.${index}.email`}
                                                                isError={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]?.email &&
                                                                    (errors?.signatories as any)
                                                                        ?.email
                                                                }
                                                                errorMessage={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]?.email &&
                                                                    (errors?.signatories as any)
                                                                        ?.email
                                                                }
                                                            />
                                                        </div>
                                                        <div className='flex-1'>
                                                            <Field
                                                                as={Input}
                                                                className='w-full'
                                                                placeholder='Enter Phone number'
                                                                label='Phone Number'
                                                                name={`signatories.${index}.phone`}
                                                                id={`signatories.${index}.phone`}
                                                                isError={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]?.phone &&
                                                                    (errors?.signatories as any)
                                                                        ?.phone
                                                                }
                                                                errorMessage={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]?.phone &&
                                                                    (errors?.signatories as any)
                                                                        ?.phone
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <Field
                                                        as={Input}
                                                        placeholder='Enter Address'
                                                        label='Address'
                                                        type='text'
                                                        name={`signatories.${index}.address`}
                                                        id={`signatories.${index}.address`}
                                                        isError={
                                                            (touched?.signatories as any)
                                                                ?.address &&
                                                            (errors?.signatories as any)
                                                                ?.address
                                                        }
                                                        errorMessage={
                                                            (touched?.signatories as any)
                                                                ?.address &&
                                                            (errors?.signatories as any)
                                                                ?.address
                                                        }
                                                    />

                                                    <div className='flex w-full gap-2 items-start'>
                                                        <div className='flex-1 w-full'>
                                                            <Field
                                                                as={Input}
                                                                className='w-full'
                                                                placeholder='Enter BVN'
                                                                label='BVN'
                                                                name={`signatories.${index}.bvn`}
                                                                id={`signatories.${index}.bvn`}
                                                                isError={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]?.bvn &&
                                                                    (errors?.signatories as any)?.[
                                                                        index
                                                                    ]?.bvn
                                                                }
                                                                errorMessage={
                                                                    (touched?.signatories as any)?.[
                                                                        index
                                                                    ]?.bvn &&
                                                                    (errors?.signatories as any)?.[
                                                                        index
                                                                    ]?.bvn
                                                                }
                                                            />
                                                        </div>

                                                        <div className='w-full flex-1'>
                                                            <label className='block mb-2 text-sm font-medium text-gray700 text-left'>
                                                                Gender
                                                            </label>
                                                            <Select
                                                                style={{
                                                                    borderRadius:
                                                                        '8px'
                                                                }}
                                                                className='w-full h-[42px] rounded-[8px]'
                                                                id='gender'
                                                                options={investmentOptions?.genders?.map(
                                                                    (opt) => ({
                                                                        label: opt,
                                                                        value: opt
                                                                    })
                                                                )}
                                                                value={
                                                                    signature.gender
                                                                }
                                                                onChange={(
                                                                    value
                                                                ) => {
                                                                    setFieldValue(
                                                                        `signatories.${index}.gender`,
                                                                        value
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className=' w-full space-y-2 items-start'>
                                                        <div className='w-full flex-1'>
                                                            <label className='block mb-2 text-sm font-medium text-gray700 text-left'>
                                                                Utility Bill
                                                                Type
                                                            </label>
                                                            <Select
                                                                style={{
                                                                    borderRadius:
                                                                        '8px'
                                                                }}
                                                                className='w-full h-[42px] rounded-[8px]'
                                                                id='utilityBillType'
                                                                options={investmentOptions?.utilityBillTypes?.map(
                                                                    (opt) => ({
                                                                        label: opt,
                                                                        value: opt
                                                                    })
                                                                )}
                                                                value={
                                                                    signature.utilityBillType
                                                                }
                                                                onChange={(
                                                                    value
                                                                ) => {
                                                                    setFieldValue(
                                                                        `signatories.${index}.utilityBillType`,
                                                                        value
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                        {signature?.utilityBillType && (
                                                            <DocumentUploader
                                                                useAuthorization
                                                                title={`Upload Utility Bill`}
                                                                runAfterUpload
                                                                accept='image/png,image/jpg,image/jpeg,application/pdf'
                                                                acceptText='PNG, JPG or PDF (max. 800x400px)'
                                                                documentItemId={
                                                                    1
                                                                }
                                                                uploaded={
                                                                    !!signature.utilityBillUrl
                                                                }
                                                                documentUrl={
                                                                    signature.utilityBillUrl ||
                                                                    ''
                                                                }
                                                                status={2}
                                                                onUpload={(
                                                                    url: string
                                                                ) => {
                                                                    setFieldValue(
                                                                        `signatories[${index}].utilityBillUrl`,
                                                                        url
                                                                    );
                                                                }}
                                                                small
                                                            />
                                                        )}
                                                    </div>

                                                    <div className=' w-full space-y-2 items-start'>
                                                        <div className='w-full flex-1'>
                                                            <label className='block mb-2 text-sm font-medium text-gray700 text-left'>
                                                                Identification
                                                                Type
                                                            </label>
                                                            <Select
                                                                style={{
                                                                    borderRadius:
                                                                        '8px'
                                                                }}
                                                                className='w-full h-[42px] rounded-[8px]'
                                                                id='identificationType'
                                                                options={investmentOptions?.idTypes?.map(
                                                                    (opt) => ({
                                                                        label: opt,
                                                                        value: opt
                                                                    })
                                                                )}
                                                                value={
                                                                    signature.identityType
                                                                }
                                                                onChange={(
                                                                    value
                                                                ) => {
                                                                    setFieldValue(
                                                                        `signatories.${index}.identityType`,
                                                                        value
                                                                    );
                                                                }}
                                                            />
                                                        </div>

                                                        {signature?.identityType && (
                                                            <DocumentUploader
                                                                useAuthorization
                                                                title={`Upload Identification`}
                                                                runAfterUpload
                                                                accept='image/png,image/jpg,image/jpeg,application/pdf'
                                                                acceptText='PNG, JPG or PDF (max. 800x400px)'
                                                                documentItemId={
                                                                    1
                                                                }
                                                                uploaded={
                                                                    !!signature.identificationUrl
                                                                }
                                                                documentUrl={
                                                                    signature.identificationUrl ||
                                                                    ''
                                                                }
                                                                status={2}
                                                                onUpload={(
                                                                    url: string
                                                                ) => {
                                                                    setFieldValue(
                                                                        `signatories[${index}].identificationUrl`,
                                                                        url
                                                                    );
                                                                }}
                                                                small
                                                            />
                                                        )}
                                                    </div>

                                                    <div className='flex justify-end gap-2 pt-4'>
                                                        <Button
                                                            text='Save'
                                                            disabled={
                                                                !hasRequiredFields
                                                            }
                                                            onClick={async () => {
                                                                try {
                                                                    await signatorySchema.validate(
                                                                        values
                                                                            .signatories[
                                                                            index
                                                                        ],
                                                                        {
                                                                            abortEarly: false
                                                                        }
                                                                    );

                                                                    setFieldValue(
                                                                        'editingIndex',
                                                                        null
                                                                    );
                                                                    setActiveKey(
                                                                        index.toString()
                                                                    );
                                                                } catch (err) {
                                                                    if (
                                                                        err instanceof
                                                                        Yup.ValidationError
                                                                    ) {
                                                                        err.inner.forEach(
                                                                            (
                                                                                validationError
                                                                            ) => {
                                                                                setFieldValue(
                                                                                    `errors.signatories.${index}.${validationError.path}`,
                                                                                    validationError.message
                                                                                );
                                                                            }
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                        <Button
                                                            text='Cancel'
                                                            variant='tertiary'
                                                            disabled={
                                                                !hasRequiredFields
                                                            }
                                                            onClick={() =>
                                                                setFieldValue(
                                                                    'editingIndex',
                                                                    null
                                                                )
                                                            }
                                                        />
                                                        <Button
                                                            text='Remove'
                                                            variant='errorSecondary'
                                                            onClick={() =>
                                                                remove(index)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                // ====================== VIEW MODE ======================
                                                <div className='space-y-2 w-full bg-[#F7FBFD] p-4 rounded-md'>
                                                    <UploadPassport
                                                        index={index}
                                                        url={
                                                            signature?.passportUrl
                                                        }
                                                    />
                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            First name
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {
                                                                signature.firstName
                                                            }
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Middle name
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {
                                                                signature.middleName
                                                            }
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Last name
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {signature.lastName}
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Email Address
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {signature.email}
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Phone number
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {signature.phone}
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Address
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {signature.address}
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Gender
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {signature.gender}
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Date of Birth
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {signature.dob}
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            BVN
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {signature.bvn}
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Utility Bill Type
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {
                                                                signature.utilityBillType
                                                            }
                                                        </p>
                                                    </div>

                                                    <div className='w-full border-b border-[#98A2B3] pb-2 border-dashed'>
                                                        <p className='font-semibold'>
                                                            Identification Type
                                                        </p>
                                                        <p className='font-light text-sm'>
                                                            {
                                                                signature.identityType
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className='flex gap-2 pt-4'>
                                                        <Button
                                                            text='Edit'
                                                            onClick={() => {
                                                                setFieldValue(
                                                                    'editingIndex',
                                                                    index
                                                                );
                                                            }}
                                                        />
                                                        <Button
                                                            text='Remove'
                                                            variant='errorSecondary'
                                                            onClick={() =>
                                                                remove(index)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </Panel>
                                    );
                                }
                            )}
                        </Collapse>

                        <Button
                            variant='tertiary'
                            className='text-appcolorprimary px-0 py-0 h-max hover:bg-transparent hover:underline cursor-pointer'
                            text='Add new signatory'
                            leftIcon={<PlusIcon color='currentColor' />}
                            type='button'
                            onClick={() => {
                                const newIndex = values.signatories.length;
                                push({
                                    firstName: '',
                                    middleName: '',
                                    lastName: '',
                                    email: '',
                                    phone: '',
                                    address: '',
                                    bvn: '',
                                    gender: '',
                                    dob: ''
                                });
                                setFieldValue('editingIndex', newIndex);
                                setActiveKey(newIndex.toString());
                                setTouched({}, false);
                            }}
                        />
                    </div>
                )}
            </FieldArray>

            <div className='pt-4 w-full'>
                <Button
                    text='Save and Continue'
                    className='w-full'
                    type='submit'
                    disabled={
                        values.editingIndex !== null ||
                        !isValid ||
                        values.signatories.length === 0
                    }
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};

export default InvestmentSignatories;

export const SignatoryIcon = (
    <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M16.6663 17.5C16.6663 16.337 16.6663 15.7555 16.5228 15.2824C16.1996 14.217 15.366 13.3834 14.3006 13.0602C13.8275 12.9167 13.246 12.9167 12.083 12.9167H7.91634C6.75337 12.9167 6.17189 12.9167 5.69872 13.0602C4.63339 13.3834 3.79971 14.217 3.47654 15.2824C3.33301 15.7555 3.33301 16.337 3.33301 17.5M13.7497 6.25C13.7497 8.32107 12.0707 10 9.99967 10C7.92861 10 6.24967 8.32107 6.24967 6.25C6.24967 4.17893 7.92861 2.5 9.99967 2.5C12.0707 2.5 13.7497 4.17893 13.7497 6.25Z'
            stroke='#0088B2'
            strokeWidth='1.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
